/**
 * owl自定义指标上报
 * @param {*} metricKey 上报指标key
 * @param {*} value 上报指标value信息
 */
const reportOwlMetric = (metricKey, value = {}) => {
    if (!window.owl || !metricKey) return;
    try {
        const metricInst = window.owl('newMetricInst');
        if (metricInst) {
            metricInst.setTags(value);
            metricInst.setMetric(metricKey, 1); // 上报指标值为1，点击一次，上报一次
        }
    } catch (error) {
        console.error('owlMetricReport Error', error);
    }
};

export default reportOwlMetric;
